export enum NicheTab {
  active = "active",
  all = "all",
}
